/*
 * WaWiReservierungenQueries.ts
 *
 * Created by Dr. Maximillian Dornseif 2023-10-22 in huWaWi3 33.2.1
 * Copyright (c) 2023 HUDORA GmbH
 */

import gql from 'graphql-tag'

import {
  RESERVIERUNGSKOPF_FRAGMENT,
  RESERVIERUNGSPOSITION_FRAGMENT,
  RESERVIERUNG_FRAGMENT,
} from '../../fragments'

export const RESERVIERUNG_STORNO_MUTATION = gql`
  mutation ReservierungStornoMutation($designator: String!, $keyStr: String!) {
    hwReservierungsStorno(designator: $designator, keyStr: $keyStr) {
      ...reservierungFragment
    }
  }
  ${RESERVIERUNG_FRAGMENT}
`

export const LIST_QUERY = gql`
  query ReservierungDetailsListQuery($cursor: String) {
    nodes: hwReservierungsKopfPages(after: $cursor, filter: { erledigt: { eq: false } }) {
      edges {
        cursor
        node {
          kunde {
            id
            name
          }
          gruppe {
            id
            name
          }
          ...reservierungKopfFragment
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
  ${RESERVIERUNGSKOPF_FRAGMENT}
`

export const RESEVIERUNG_QUERY = gql`
  query ReservierungKopfQuery($nr: ID!) {
    entity: hwReservierungsKopf(designator: $nr) {
      ...reservierungKopfFragment
    }
  }
  ${RESERVIERUNGSKOPF_FRAGMENT}
`

export const RESEVIERUNG_DETAILS_QUERY = gql`
  query ResevierungDetailsQuery($nr: ID!) {
    entity: hwReservierungsKopf(designator: $nr) {
      id
      kunde {
        id
        name
      }
      gruppe {
        id
        name
      }
    }
  }
`

export const POSITIONEN_QUERY = gql`
  query ResevierungPositionenQuery($nr: ID!) {
    entity: hwReservierungsKopf(designator: $nr) {
      id
      positionen {
        ...resevierungspositionFragment
        item {
          id
          name
        }
      }
    }
  }
  ${RESERVIERUNGSPOSITION_FRAGMENT}
`

export const PATCH_MUTATION = gql`
  mutation ResevierungsPatch($designator: ID!, $input: HwReservierungPatchInput!, $oldRev: ID!) {
    patchInfo: hwReservierungPatch(designator: $designator, input: $input, oldRev: $oldRev) {
      old {
        ...reservierungFragment
      }
      new {
        ...reservierungFragment
      }
      oldRev
      newRev
      duration
      success
      errors
      audit {
        created_at
        typ
        uid
        user
        text
        new
        old
      }
    }
  }
  ${RESERVIERUNG_FRAGMENT}
`

export const STORNO_LIST_QUERY = gql`
  query ResevierungStornosListQuery($nr: ID!) {
    entity: hwReservierung(designator: $nr) {
      nodes: stornos {
        id
        bartnr
        artnr
        menge_storniert
        preis
        wert
        anlieferdatum_von
        anlieferdatum_bis
        grund
        reservierungsnr
        designator
        created_at
        updated_at
        erfasst_von
      }
    }
  }
`

export const ABRUF_LIST_QUERY = gql`
  query ResevierungAbrufeListQuery($nr: ID!) {
    entity: hwReservierung(designator: $nr) {
      nodes: abrufe {
        id
        auftragsnr
        posnr_auftrag
        menge
        artnr
        bartnr
        empfaengernr
        created_at
        updated_at
      }
    }
  }
`

export const AUDIT_LIST_QUERY = gql`
  query ResevierungAuditQuery($nr: ID!) {
    entity: hwReservierung(designator: $nr) {
      nodes: auditLog {
        id
        designator
        level
        object_name
        message
        src_file
        src_func
        src_line
        gae_version
        gae_service
        created_by2
        created_by {
          email
        }
        created_at
        updated_at
      }
    }
  }
`
